export default (
  <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M127.498 255.275C197.792 255.275 254.777 198.29 254.777 127.996C254.777 57.7014 197.792 0.716492 127.498 0.716492C57.2036 0.716492 0.21875 57.7014 0.21875 127.996C0.21875 198.29 57.2036 255.275 127.498 255.275Z"
      fill="#00357C"
    />
    <path
      d="M27.0269 240.084C28.3985 237.029 27.0269 233.412 23.9407 232.01C20.8857 230.638 17.2696 231.978 15.898 235.033C14.5264 238.088 15.8357 241.736 18.9218 243.139C21.9768 244.51 25.6552 243.139 27.0269 240.084Z"
      fill="#D2E0FF"
    />
    <path
      d="M36.0373 252.054C36.9101 250.09 36.0373 247.783 34.0734 246.91C32.1406 246.038 29.8338 246.879 28.9609 248.843C28.0881 250.776 28.9298 253.114 30.8937 253.987C32.7952 254.891 35.1332 254.018 36.0373 252.054Z"
      fill="#D2E0FF"
    />
    <path
      d="M240.067 16.9452C242.249 14.389 241.937 10.5235 239.381 8.34135C236.825 6.15922 232.99 6.43978 230.808 8.99599C228.626 11.5522 228.876 15.4177 231.432 17.5998C233.957 19.7819 237.885 19.5014 240.067 16.9452Z"
      fill="#D6DCE8"
    />
    <path
      d="M245.334 30.9732C246.737 29.3521 246.518 26.8895 244.897 25.4867C243.276 24.0839 240.845 24.2709 239.442 25.8919C238.039 27.5129 238.226 29.9756 239.847 31.3784C241.468 32.7812 243.931 32.5942 245.334 30.9732Z"
      fill="#D6DCE8"
    />
    <path
      d="M22.6918 29.0092C24.8739 26.453 24.5622 22.5875 22.006 20.4054C19.4498 18.2233 15.6155 18.5038 13.4333 21.06C11.2512 23.6163 11.5006 27.4817 14.0568 29.6639C16.5818 31.846 20.5097 31.5654 22.6918 29.0092Z"
      fill="#D2E0FF"
    />
    <path
      d="M233.673 63.7674V236.249C233.673 246.755 225.163 255.296 214.627 255.296H58.1055C47.6001 255.296 39.0586 246.786 39.0586 236.249V19.7508C39.0586 9.24537 47.5689 0.703888 58.1055 0.703888H166.682C167.68 0.703888 168.646 0.797407 169.612 0.9221C173.291 1.48322 176.751 3.1354 179.525 5.72279L227.501 49.7395C230.369 52.358 232.333 55.7871 233.175 59.4967C233.486 60.8995 233.673 62.3023 233.673 63.7674Z"
      fill="#8AABF8"
    />
    <path
      d="M233.176 59.4967H178.809C173.728 59.4967 169.582 55.3818 169.582 50.2694V0.922089C173.26 1.48321 176.721 3.13539 179.495 5.72277L227.471 49.7395C230.37 52.358 232.334 55.7871 233.176 59.4967Z"
      fill="#D2E0FF"
    />
    <path
      d="M141.961 29.1339V22.1823C141.961 21.777 141.649 21.4653 141.244 21.4653H74.2521C73.8469 21.4653 73.5352 21.777 73.5352 22.1823V29.1339C73.5352 29.5392 73.8469 29.8509 74.2521 29.8509H141.244C141.649 29.8509 141.961 29.5392 141.961 29.1339Z"
      fill="#D2E0FF"
    />
    <path
      d="M141.961 108.002V101.051C141.961 100.645 141.649 100.334 141.244 100.334H74.2521C73.8469 100.334 73.5352 100.645 73.5352 101.051V108.002C73.5352 108.408 73.8469 108.719 74.2521 108.719H141.244C141.649 108.719 141.961 108.408 141.961 108.002Z"
      fill="#D2E0FF"
    />
    <path
      d="M114.559 48.9913V42.0396C114.559 41.6344 114.247 41.3227 113.842 41.3227H74.2521C73.8469 41.3227 73.5352 41.6344 73.5352 42.0396V48.9913C73.5352 49.3965 73.8469 49.7083 74.2521 49.7083H113.842C114.247 49.7083 114.559 49.3965 114.559 48.9913Z"
      fill="#D2E0FF"
    />
    <path
      d="M253.817 178.392V212.745C253.817 215.768 251.385 218.169 248.361 218.169H141.25C146.924 212.339 150.446 204.359 150.446 195.568C150.446 186.746 146.924 178.766 141.25 172.936H248.361C251.354 172.936 253.817 175.368 253.817 178.392Z"
      fill="#D2E0FF"
    />
    <path
      d="M248.358 220.133H136.539L139.812 216.766C145.392 211.03 148.447 203.517 148.447 195.568C148.447 187.588 145.392 180.044 139.812 174.308L136.539 170.941H248.358C252.472 170.941 255.777 174.277 255.777 178.36V212.713C255.777 216.828 252.441 220.133 248.358 220.133ZM145.548 216.174H248.326C250.228 216.174 251.787 214.646 251.787 212.745V178.392C251.787 176.49 250.228 174.931 248.326 174.931H145.548C150.006 180.854 152.437 188.055 152.437 195.568C152.437 203.081 150.037 210.251 145.548 216.174Z"
      fill="#5E89ED"
    />
    <path
      d="M85.7617 195.568C85.7617 213.399 100.226 227.895 118.12 227.895C135.951 227.895 150.446 213.43 150.446 195.568C150.446 177.675 135.982 163.21 118.12 163.21C100.257 163.21 85.7617 177.675 85.7617 195.568Z"
      fill="#D2E0FF"
    />
    <path
      d="M118.119 229.89C99.1652 229.89 83.7656 214.49 83.7656 195.599C83.7656 176.646 99.1652 161.246 118.119 161.246C137.041 161.246 152.409 176.646 152.409 195.599C152.44 214.49 137.041 229.89 118.119 229.89ZM118.119 165.205C101.379 165.205 87.7558 178.828 87.7558 195.568C87.7558 212.277 101.379 225.9 118.119 225.9C134.827 225.9 148.45 212.308 148.45 195.568C148.45 178.828 134.859 165.205 118.119 165.205Z"
      fill="#5E89ED"
    />
    <path
      d="M139.998 195.568C139.998 207.663 130.178 217.452 118.114 217.452C105.988 217.452 96.1992 207.632 96.1992 195.568C96.1992 183.442 106.019 173.653 118.114 173.653C130.209 173.653 139.998 183.442 139.998 195.568Z"
      fill="#5E89ED"
    />
    <path
      d="M109.541 201.242C103.181 194.882 107.795 184.096 116.648 184.065C125.564 184.065 130.053 194.913 123.756 201.242C119.859 205.169 113.5 205.169 109.541 201.242ZM116.679 188.055C111.318 188.055 108.512 194.602 112.346 198.436C114.653 200.743 118.643 200.743 120.95 198.436C124.816 194.602 122.072 188.055 116.679 188.055Z"
      fill="#D2E0FF"
    />
    <path
      d="M127.463 206.915C126.964 206.915 126.434 206.728 126.06 206.323L120.979 201.242C120.2 200.462 120.2 199.215 120.979 198.436C121.758 197.657 123.005 197.657 123.785 198.436L128.866 203.517C129.645 204.297 129.645 205.544 128.866 206.323C128.492 206.697 127.962 206.915 127.463 206.915Z"
      fill="#D2E0FF"
    />
    <path
      d="M199.195 123.714V129.325C199.195 130.135 198.54 130.759 197.761 130.759H74.9691C74.1586 130.759 73.5352 130.104 73.5352 129.325V123.714C73.5352 122.903 74.1898 122.28 74.9691 122.28H197.73C198.54 122.249 199.195 122.903 199.195 123.714Z"
      fill="#D2E0FF"
    />
    <path
      d="M199.195 143.727V149.338C199.195 150.149 198.54 150.772 197.761 150.772H74.9691C74.1586 150.772 73.5352 150.117 73.5352 149.338V143.727C73.5352 142.916 74.1898 142.293 74.9691 142.293H197.73C198.54 142.293 199.195 142.948 199.195 143.727Z"
      fill="#D2E0FF"
    />
    <path
      d="M64.9339 118.57C65.3391 120.596 63.4064 122.28 61.4425 121.687L50.5942 118.227C45.3882 120.628 39.5276 121.781 33.3242 121.282C16.3971 120.004 2.71199 106.319 1.34037 89.3919C-0.374164 67.82 17.5193 49.9577 39.1224 51.7657C55.8624 53.1685 69.454 66.7289 70.8568 83.469C71.6673 93.1015 68.6123 101.955 63.0635 108.688L64.9339 118.57Z"
      fill="#5E89ED"
    />
    <path
      d="M34.2979 93.8185C32.8328 93.8185 31.6482 92.6339 31.6482 91.1688V89.2361C31.6482 86.1499 33.4874 83.3755 36.3553 82.1909C38.4128 81.318 39.7532 79.2294 39.6909 76.985C39.5038 72.496 33.955 70.0021 30.5571 73.3065C29.4972 74.3352 28.9049 75.7068 28.9049 77.2032C28.9049 78.6683 27.7203 79.8529 26.2552 79.8529C24.7901 79.8529 23.6055 78.6683 23.6055 77.2032C23.6055 74.2729 24.7589 71.5296 26.8787 69.5034C33.5186 63.1128 44.6163 67.633 44.9592 76.7979C45.115 81.2557 42.4965 85.3706 38.3816 87.0851C37.5088 87.4592 36.9165 88.3009 36.9165 89.2672V91.2C36.9476 92.6339 35.763 93.8185 34.2979 93.8185Z"
      fill="#D2E0FF"
    />
    <path
      d="M37.8808 100.926C37.8808 102.921 36.291 104.511 34.2959 104.511C32.3008 104.511 30.7109 102.89 30.7109 100.926C30.7109 98.9309 32.3319 97.3411 34.2959 97.3411C36.2598 97.3411 37.8808 98.9621 37.8808 100.926Z"
      fill="#D2E0FF"
    />
  </svg>
)
